/**
 *
 * Asynchronously loads the component for PriceInformation
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PriceInformation = lazyLoad(
  () => import('./index'),
  module => module.PriceInformation,
);
